<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        ref="table"
        :loading="loading"
        highlight-row
        :columns="companyColumns"
        @on-row-click="rowClick"
        :data="companyData"
        width="100%"
        stripe
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">公司资产</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        label-position="left"
        inline
        :disabled="corparateDisable"
        v-if="showSelfData.CorporateAssets == '1'"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="val == 'date' || val == 'returndate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Checkbox
            v-else-if="val == 'status'"
            v-model="formItem[val]"
            style="min-width: 250px;"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" @click="saveData()" :disabled="corparateDisable"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      assetsType: [
        {
          value: "资产类型",
          label: "资产类型"
        }
      ],
      companyData: [],
      serialnumber: "0001",
      loading: false,
      corparateDisable: false,
      showSelfData: {},
      plan: "",
      chNameMap: {},
      enNameMap: {},
      id: null,
      userId: "",
      sortfMap: {},
      disableSelfData: {}
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    companyColumns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.propertyno
              : this.enNameMap.propertyno,
          key: "propertyno",
          align: "center",
          minWidth: 220
        },
        {
          title: this.lang == "zh" ? this.chNameMap.type : this.enNameMap.type,
          key: "type",
          align: "center",
          minWidth: 220
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.brand : this.enNameMap.brand,
          key: "brand",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.model : this.enNameMap.model,
          key: "model",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.serialno
              : this.enNameMap.serialno,
          key: "serialno",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.curvalue
              : this.enNameMap.curvalue,
          key: "curvalue",
          align: "center",
          minWidth: 180
        },
        {
          title: this.lang == "zh" ? this.chNameMap.date : this.enNameMap.date,
          key: "date",
          align: "center",
          minWidth: 220,
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.date, "YYYY-MM-DD"));
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.status : this.enNameMap.status,
          key: "status",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            var name1 = "";
            if (params.row.status == "0") {
              name1 = "否";
            }
            if (params.row.status == "1") {
              name1 = "是";
            }
            return h("span", name1);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.returndate
              : this.enNameMap.returndate,
          key: "returndate",
          align: "center",
          minWidth: 220,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.returndate, "YYYY-MM-DD")
            );
          }
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    initCorparate(item) {
      this.loading = true;
      let Obj = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1"
      };
      axios
        .post("/CorporateAsset/researchUserCorporateAssetInfo", Obj)
        .then(res => {
          if (res) {
            this.companyData = res.data;
            this.disableSelfData = res.disableSelfData;
            if (res.disableSelfData.CorporateAssets == "0") {
              this.corparateDisable = true;
            }
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.showSelfData = res.showSelfData;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[14];
          }
          this.loading = false;
        });
    },
    rowClick(row, index) {
      this.formItem = row;
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          axios
            .post(
              "/CorporateAsset/rollBackUserCorporateAssetInfo",
              this.formItem
            )
            .then(res => {
              this.initCorparate();
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    },
    getData(item, plan) {
      this.plan = plan ? plan : "";
      (this.id = item), this.initCorparate();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 640px) {
  .formCol {
    width: 100%;
    margin-right: 0px;
  }
  .photoava {
    margin-top: 0px;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/CorporateAssets.vue